import React, { useState } from "react";
import PropTypes from "prop-types";
import { Modal, ModalBody, ModalFooter, Button, Row, Alert } from "reactstrap";
import i18n from "../../../i18n";
import { delSubAdminsCostCenter } from "../../../helpers/api_rombo_helper";

const DeleteSubAdminModal = ({ isOpen, toggle, setDeleteModal, setShowAlertSuccess, setTextHeader, setTextBody, clickUser, setClickUser, setReloadUsers, token, reloadUsers, costCenterId }) => {

  const [localErrorAlert, setLocalErrorAlert] = useState(false);
  const [localErrorAlertMessage, setLocalErrorAlertMessage] = useState(null);

  function onClickDelete() {
    if (!clickUser.id) return;
  
    let body = {
      user_id: String(clickUser.id),
      cost_center_id: String(costCenterId),
    };
  
    delSubAdminsCostCenter(token, body)
      .then(() => {
  
        setDeleteModal(false);
        setShowAlertSuccess(true);
        setClickUser({});
        setTextHeader(i18n.t("SubAdminDeleted"));
        setTextBody(i18n.t("SubAdminDeletedText"));
        setReloadUsers(!reloadUsers);
      })
      .catch((error) => {
        console.error("Error - delSubAdminsCostCenter:", error);
        console.error("Backend response:", error.response?.data);
      
        setLocalErrorAlertMessage(error.response?.data?.detail || error.message);
        if (error.code === 500) {
          setLocalErrorAlertMessage(i18n.t("ServerError"));
        }
        setLocalErrorAlert(true);
      });      
  }  

  return (
    <Modal
      isOpen={isOpen}
      role="dialog"
      autoFocus={true}
      centered={true}
      className="RequestModal"
      tabIndex="-1"
      toggle={toggle}
      backdrop={'static'}
      id="staticBackdrop"
      size={"lg"}
    >
      <div className="modal-content">
        <p className="cancellation-title">{i18n.t("DeleteSubAdmin")}</p>
        <p className="cancellation-confirmation modal-header-bottom">{i18n.t("Confirmation")}</p>
        <div className="modal-separator" />
        <ModalBody className="mt-0 pt-0">
          <Alert
            color="danger"
            isOpen={localErrorAlert}
            toggle={() => setLocalErrorAlert(false)}
          >
            {localErrorAlertMessage}
          </Alert>
          <Row>
            <p className="cancellation-text">{i18n.t("TextDeleteSubAdmin")}</p>
            <p className="cancellation-text">
              - {clickUser.full_name} ({clickUser.email})
            </p>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button className="btn-users border" type="button" onClick={onClickDelete}>
            {i18n.t("Accept")}
          </Button>
          <Button className="btn-light" type="button" data-dismiss="modal" onClick={toggle}>
            {i18n.t("GoBack")}
          </Button>
        </ModalFooter>
      </div>
    </Modal>
  );
};

DeleteSubAdminModal.propTypes = {
  isOpen: PropTypes.bool,
  toggle: PropTypes.func,
  setDeleteModal: PropTypes.func,
  setShowAlertSuccess: PropTypes.func,
  setTextHeader: PropTypes.func,
  setTextBody: PropTypes.func,
  setErrorAlert: PropTypes.func,
  setErrorAlertMessage: PropTypes.func,
  clickUser: PropTypes.object,
  token: PropTypes.string,
  setReloadUsers: PropTypes.func,
  setClickUser: PropTypes.func,
  costCenterId: PropTypes.string,
  reloadUsers: PropTypes.bool,
};

export default DeleteSubAdminModal;
